import { ActionContext, ActionTree } from "vuex";
import { GetterTree } from "vuex";
import { StompClient } from "@/service/StompClient";

export interface SocketState {
  socket: StompClient;
  isConnecting: boolean;
}

const initialState: SocketState = {
  socket: new StompClient(),
  isConnecting: false
};

const actions: ActionTree<SocketState, any> = {
  connect({ commit }: ActionContext<SocketState, any>, payload?: any): void {
    commit("connect", payload);
  },
  disconnect({ commit }: ActionContext<SocketState, any>): void {
    commit("disconnect");
  }
};

const mutations = {
  connect(state: SocketState, payload?: any) {
    if(state.isConnecting) {
      if (payload) {
        mutations.callbackConnected(state, payload);
      }
    } else if(!state.socket.isConnected()) {
      state.isConnecting = true;
      state.socket.connect(payload);
    } else if(payload) {
      payload();
    }
  },
  disconnect(state: SocketState) {
    if(state.socket.isConnected()) {
      state.isConnecting = false;
      state.socket.disconnect();
    }
  },
  callbackConnected(state: SocketState, payload:any) {
    setTimeout(() => {
      if(state.socket.isConnected()) {
        state.isConnecting = false;
        payload();
      } else {
        mutations.callbackConnected(state, payload);
      }
    }, 500);
  }
};

const getters: GetterTree<SocketState, any> = {
  socket(state: SocketState): StompClient {
    return state.socket;
  }
};

const namespaced: boolean = true;
export default {
  namespaced,
  state: { ...initialState },
  getters,
  actions,
  mutations
};
